import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import * as Yup from "yup";
import postData from "../../../lib/Axios";
import { formatDate, showError } from "../../../lib/GeneralFunction";
import { useRouter } from "next/router";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import axios from "axios";

const OtpForm = ({ toast, state, setFieldValue, setErrors, setState }) => {
  const router = useRouter();
  const inputRef = useRef([]);

  const [otpState, setOtpState] = useState({
    show: false,
    otpKode: ["", "", "", ""],
    expires: "",
    load: false,
    countDownResend: 60,
    disableResend: true,
  });

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Harus diisi"),
    no_hp: Yup.string()
      .max(15, "Maksimal nomor hp adalah 15 karakter")
      .min(11, "Minimil nomor hp adalah 11 karakter")
      .required("Harus diisi"),
  });

  const onHandleSubmit = async (e = {}) => {
    if (Object.keys(e).length > 0) {
      e.preventDefault();
    }
    setOtpState((p) => ({ ...p, load: true }));
    try {
      const data = {
        email: state?.values?.email,
        no_hp: state?.values?.no_hp,
      };

      let isError = false;
      await validationSchema.validate(data, { abortEarly: false }).catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });

        if (Object.keys(newErrors).length > 0) {
          isError = true;
        }
        setErrors(newErrors);
      });

      if (isError) {
        return;
      }

      // const headers = {
      //   // "X-Credential": JSON.stringify({}),
      //   // "X-Level": "0",
      // };
      const header = { "Content-Type": "application/json;charset=UTF-8" };

      const payload = {
        email: data.email,
        no_hp: data.no_hp,
      };

      const { data: oRes } = await axios.post("/api/otp/send", payload, { headers: header });
      console.log(oRes.data);
      const expired = formatDate(oRes.data.expired, "HH:mm");
      setOtpState((p) => ({ ...p, show: true, expires: expired }));
    } catch (error) {
      // console.log(error);
      const e = error?.response?.data || error;
      showError(toast, e.message || "Internal server error");
    } finally {
      setOtpState((p) => ({ ...p, load: false }));
    }
  };

  const verifOtp = async () => {
    setOtpState((p) => ({ ...p, load: true }));
    try {
      const header = { "Content-Type": "application/json;charset=UTF-8" };

      //   const headers = {
      //     "X-Level": "0",
      //   };

      const payload = { kode: otpState?.otpKode.join("") };

      const { data: oRes } = await axios.post("/api/otp/verif", payload, {
        headers: header,
      });
      console.log(oRes.data);
      setOtpState((p) => ({ ...p, show: false }));
      setState((p) => ({ ...p, isVerified: true }));
    } catch (error) {
      console.log(error);
      const e = error?.response?.data || error;
      showError(toast, e.message || "Internal server error");
    } finally {
      setOtpState((p) => ({ ...p, load: false }));
    }
  };

  useEffect(() => {
    let timer;

    if (otpState?.countDownResend > 0 && otpState?.show) {
      timer = setInterval(() => {
        setOtpState((p) => ({ ...p, countDownResend: p.countDownResend - 1, disableResend: true }));
      }, 1000);
    }

    if (otpState?.countDownResend === 0) {
      setOtpState((p) => ({ ...p, disableResend: false }));
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [otpState?.countDownResend, otpState?.disableResend, otpState?.show]);

  useEffect(() => {
    console.log(otpState?.disableResend);
  }, [otpState?.otpKode]);

  return (
    <>
      <form onSubmit={onHandleSubmit} className="p-fluid flex flex-column">
        <div className="flex flex-column gap-2">
          <div className="flex gap-2 w-full">
            <div className="field mb-4 w-full">
              <label htmlFor="email" className="block text-900 font-medium mb-2">
                Email
              </label>
              <InputText
                id="email"
                type="text"
                value={state?.values?.email}
                onChange={(e) => setFieldValue("email", e.target.value)}
                className={classNames({ "p-invalid": state?.errors?.email })}
                placeholder="test@gmail.com"
                style={{ padding: "1rem" }}
              />

              {state?.errors?.email && <small className="p-error block">{state?.errors?.email}</small>}
            </div>
          </div>
          <div className="field mb-4 w-full">
            <label htmlFor="no_hp" className="block text-900 font-medium mb-2">
              Contact WhatsApp
            </label>
            <InputText
              id="no_hp"
              keyfilter={"int"}
              value={state?.values?.no_hp}
              onChange={(e) => setFieldValue("no_hp", e.target.value)}
              className={classNames({ "p-invalid": state?.errors?.no_hp })}
              placeholder="089111222333"
              style={{ padding: "1rem" }}
            />
            {state?.errors?.no_hp && <small className="p-error block">{state?.errors?.no_hp}</small>}
          </div>
        </div>

        <div className="flex gap-2 mt-4">
          <button
            style={{
              borderRadius: "2px",
              padding: "0.75rem",
              border: "none",
            }}
            className={`flex align-items-center justify-content-between gap-2 rounded bg-green-500 text-white font-medium hover:bg-green-600 disabled:bg-gray-400 transition w-full`}
            disabled={otpState?.load}
            type="submit">
            <>
              <i className={`${otpState?.load ? "pi pi-spin pi-spinner" : "pi pi-user"}`}></i>
              <span className="w-full">Kirim Otp</span>
            </>
          </button>

          {/* <span className="text-600 font-medium">Already have an account? </span>
          <Link href="/auth/login" className="text-primary font-medium no-underline hover:text-primary-600">
          Login here
          </Link> */}
          <Link
            href={"/auth/login"}
            style={{
              borderRadius: "2px",
              padding: "0.75rem",
            }}
            className={`flex align-items-center text-center justify-content-between gap-2 rounded bg-yellow-500 text-white font-medium hover:bg-yellow-600 disabled:bg-gray-400 transition w-full`}>
            <>
              <i className={`${otpState.load ? "pi pi-spin pi-spinner" : "pi pi-user"}`}></i>
              <span className="w-full">Sign In</span>
            </>
          </Link>
        </div>
      </form>

      <Dialog
        style={{ width: "30%" }}
        dismissableMask
        visible={otpState?.show}
        onHide={() => {
          setOtpState((p) => ({ ...p, show: false, countDownResend: 60, disableResend: true }));
        }}>
        <div className="w-full flex flex-column gap-2 justify-content-center">
          <div className="flex gap-2 flex-column mb-3">
            <span className="text-center font-bold">Masukkan kode OTP yang anda dapatkan</span>
            <span className="text-center font-bold">Cek gmail anda</span>
          </div>
          <div className="flex gap-2 py-2 justify-content-center">
            {otpState?.otpKode.map((v, i) => {
              return (
                <InputText
                  id="kode"
                  key={i}
                  className="w-2"
                  keyfilter={"int"}
                  value={v}
                  maxLength={1}
                  onChange={(e) => {
                    const val = e.target.value;
                    setOtpState((p) => {
                      const kode = [...p.otpKode];
                      kode[i] = val;
                      return { ...p, otpKode: kode };
                    });

                    if (val && i + 1 < otpState?.otpKode.length) {
                      inputRef.current[i + 1].focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key == "Backspace" && i > 0) {
                      console.log(i);
                      setOtpState((p) => {
                        const kode = [...p.otpKode];
                        kode[i] = "";
                        return { ...p, otpKode: kode };
                      });

                      inputRef.current[i - 1].focus();
                    }

                    if (e.key == "Enter" && i == 3) {
                      verifOtp();
                    }
                  }}
                  ref={(el) => (inputRef.current[i] = el)}
                  style={{ padding: "1rem" }}
                />
              );
            })}
          </div>

          <div className="flex gap-2 justify-content-center flex-column">
            <span className="text-center" style={{ fontSize: "14px" }}>
              Kirim ulang <b>{otpState?.countDownResend}</b>
            </span>
            <p className="text-center">
              Kode terkirim berlaku sampai : <b>{otpState?.expires}</b>
            </p>

            <div className="flex justify-content-between">
              <Button
                label="Resend kode"
                disabled={otpState?.disableResend}
                onClick={() => {
                  onHandleSubmit();
                  setOtpState((p) => ({ ...p, countDownResend: 60, disableResend: true }));
                }}
              />
              <Button loading={otpState?.load} severity="info" label="Kirim" onClick={() => verifOtp()} />
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default OtpForm;
